export default __webpack_public_path__ + "static/media/imagen02.c42f3221.svg";